/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Pricechart_Last3months2Inputs */

const id_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 bulan terakhir`)
};

const ms_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 bulan lepas`)
};

const da_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidste 3 måneder`)
};

const de_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte 3 Monate`)
};

const en_us2_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 3 months`)
};

const es_es2_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos 3 meses`)
};

const es_mx2_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos 3 meses`)
};

const fil_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huling 3 buwan`)
};

const fr_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 derniers mois`)
};

const it_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimi 3 mesi`)
};

const hu_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utolsó 3 hónap`)
};

const nl_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatste 3 maanden`)
};

const no_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siste 3 måneder`)
};

const pl_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnie 3 miesiące`)
};

const pt_br2_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 3 months`)
};

const pt_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos 3 meses`)
};

const ro_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimele 3 luni`)
};

const fi_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeiset 3 kuukautta`)
};

const sv_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste 3 månaderna`)
};

const vi_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 tháng qua`)
};

const tr_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son 3 ay`)
};

const cs_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslední 3 měsíce`)
};

const bg_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последни 3 месеца`)
};

const ru_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние 3 месяца`)
};

const uk_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останні 3 місяці`)
};

const ar_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آخر 3 أشهر`)
};

const hi_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछले 3 महीने`)
};

const th_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 เดือนที่ผ่านมา`)
};

const ja_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`過去3ヶ月`)
};

const zh_cn2_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 3 months`)
};

const zh_hant1_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 3 months`)
};

const ko_components_pricechart_last3months2 = /** @type {(inputs: Components_Pricechart_Last3months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 3 months`)
};

/**
* | output |
* | --- |
* | "Last 3 months" |
*
* @param {Components_Pricechart_Last3months2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_pricechart_last3months2 = /** @type {((inputs?: Components_Pricechart_Last3months2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Pricechart_Last3months2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_pricechart_last3months2(inputs)
	if (locale === "ms") return ms_components_pricechart_last3months2(inputs)
	if (locale === "da") return da_components_pricechart_last3months2(inputs)
	if (locale === "de") return de_components_pricechart_last3months2(inputs)
	if (locale === "en-US") return en_us2_components_pricechart_last3months2(inputs)
	if (locale === "es-ES") return es_es2_components_pricechart_last3months2(inputs)
	if (locale === "es-MX") return es_mx2_components_pricechart_last3months2(inputs)
	if (locale === "fil") return fil_components_pricechart_last3months2(inputs)
	if (locale === "fr") return fr_components_pricechart_last3months2(inputs)
	if (locale === "it") return it_components_pricechart_last3months2(inputs)
	if (locale === "hu") return hu_components_pricechart_last3months2(inputs)
	if (locale === "nl") return nl_components_pricechart_last3months2(inputs)
	if (locale === "no") return no_components_pricechart_last3months2(inputs)
	if (locale === "pl") return pl_components_pricechart_last3months2(inputs)
	if (locale === "pt-BR") return pt_br2_components_pricechart_last3months2(inputs)
	if (locale === "pt") return pt_components_pricechart_last3months2(inputs)
	if (locale === "ro") return ro_components_pricechart_last3months2(inputs)
	if (locale === "fi") return fi_components_pricechart_last3months2(inputs)
	if (locale === "sv") return sv_components_pricechart_last3months2(inputs)
	if (locale === "vi") return vi_components_pricechart_last3months2(inputs)
	if (locale === "tr") return tr_components_pricechart_last3months2(inputs)
	if (locale === "cs") return cs_components_pricechart_last3months2(inputs)
	if (locale === "bg") return bg_components_pricechart_last3months2(inputs)
	if (locale === "ru") return ru_components_pricechart_last3months2(inputs)
	if (locale === "uk") return uk_components_pricechart_last3months2(inputs)
	if (locale === "ar") return ar_components_pricechart_last3months2(inputs)
	if (locale === "hi") return hi_components_pricechart_last3months2(inputs)
	if (locale === "th") return th_components_pricechart_last3months2(inputs)
	if (locale === "ja") return ja_components_pricechart_last3months2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_pricechart_last3months2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_pricechart_last3months2(inputs)
	return ko_components_pricechart_last3months2(inputs)
});
export { components_pricechart_last3months2 as "components.priceChart.last3Months" }